import { FilterData, } from "@domains/aggregates/interfaces/Reports/iReportsCommon";
import FilterLabels from "@frameworks/web/components/generic/FilterLabels/FilterLabels";
import React, { useEffect, useRef, useState, } from "react";
import DeviceContext from "@frameworks/web/utils/indentifyDevice";
import di from "@frameworks/web/components/Reports/PNLReports/di/servicelocator";
const PNLFilterLabelDynamic = (props) => {
    const [appliedFilters, setAppliedFilters] = useState();
    const filterRef = useRef(null);
    const constructFilterHelper = (FILTERS, filterName) => {
        let filter = FILTERS.findIndex((filter) => filter.name === filterName);
        if (filter > -1)
            return FILTERS[filter].filters;
        return props.filterData[FILTERS[filter].name].filters;
    };
    const constructFilters = () => {
        let FilterInSession = [];
        let FilterInSessionSimpleFilter = [];
        Object.values(props.filterData).forEach((x) => {
            if (x) {
                let name = x.name == "Filter By" ? "simpleFilter" : x.name;
                if (name) {
                    let filter = JSON.parse(sessionStorage.getItem(name));
                    if (filter)
                        name == "simpleFilter"
                            ? FilterInSessionSimpleFilter.push(filter)
                            : FilterInSession.push(filter);
                }
            }
        });
        if (FilterInSessionSimpleFilter && FilterInSessionSimpleFilter.length > 0)
            setAppliedFilters((prevState) => {
                props.filterData.simpleFilter.filters.forEach((x) => {
                    let idxFound = FilterInSessionSimpleFilter.findIndex((p) => {
                        p.find((d) => d.key[1] === x.key);
                    });
                    if (idxFound > -1)
                        x.selected = true;
                });
                return new FilterData({
                    name: di.pnlReport.filterState.simpleFilter.name,
                    filters: props.filterData.simpleFilter.filters,
                }, {
                    name: "",
                    filters: [],
                });
            });
        if (props.tabName === "derivative" &&
            FilterInSession &&
            FilterInSession.length > 0)
            setAppliedFilters((prevState) => {
                let FILTERS = [];
                Object.values(props.filterData).forEach((x) => {
                    if (x && x.name != "Filter By") {
                        x.filters.map((y) => {
                            let idxFound = FilterInSession[0][0].value.findIndex((m) => m == y.key);
                            if (idxFound > -1)
                                y.selected = true;
                        });
                        FILTERS.push(x);
                    }
                });
                return new FilterData({
                    name: di.pnlReport.filterState.simpleFilter.name,
                    filters: props.filterData.simpleFilter.filters,
                }, {
                    name: "",
                    filters: [],
                }, {
                    name: props.filterData.productAssetFilter.name,
                    filters: props.filterData.productAssetFilter.filters,
                }, {
                    name: di.pnlReport.filterState.underlyingAsset.name,
                    filters: constructFilterHelper(FILTERS, di.pnlReport.filterState.underlyingAsset.name),
                }, {
                    name: di.pnlReport.filterState.expiryMonth.name,
                    filters: constructFilterHelper(FILTERS, di.pnlReport.filterState.expiryMonth.name),
                }, {
                    name: di.pnlReport.filterState.instrumentType.name,
                    filters: constructFilterHelper(FILTERS, di.pnlReport.filterState.instrumentType.name),
                }, {
                    name: di.pnlReport.filterState.optionType.name,
                    filters: constructFilterHelper(FILTERS, di.pnlReport.filterState.optionType.name),
                }, {
                    name: di.pnlReport.filterState.strikePrice.name,
                    filters: constructFilterHelper(FILTERS, di.pnlReport.filterState.strikePrice.name),
                });
            });
    };
    useEffect(() => {
        if (props.filterData)
            constructFilters();
    }, [props.filterData]);
    return (React.createElement("div", { className: "d-flex", ref: filterRef }, appliedFilters &&
        props.filterData &&
        Object.entries(appliedFilters).map((val) => {
            if (val[1] && val[1].filters)
                return val[1].filters.map((tags, idxb) => {
                    return (tags.selected && (React.createElement("div", { className: DeviceContext().isDesktop ? " " : `filter-tags`, key: idxb },
                        React.createElement(FilterLabels, { LabelText: tags.title, closeBtn: true, FilterAction: (filtername) => di.pnlReport.removeOneFilter(filtername, props.tabName) }))));
                });
        })));
};
export default PNLFilterLabelDynamic;
